<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Lịch nghỉ" :link="[{ text: 'Lịch nghỉ', href: '../schedule-vacations' }]" />
      </div>
      <div class="d-flex flex-wrap justify-end flex-gap">
        <v-btn class="ml-6" dark depressed color="#0D47A1" @click="() => $refs['create-dialog'].openDialog()">
          <v-icon left>add</v-icon> Thêm lịch nghỉ
        </v-btn>
      </div>
    </div>
    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <VacationFilter />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <VacationTable />
    </v-card>

    <VacationCreateDialog ref="create-dialog" />
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import VacationFilter from './components/VacationFilter.vue'
import VacationTable from './components/VacationTable.vue'
import VacationCreateDialog from './components/VacationCreateDialog.vue'

export default {
  components: { Breadcrumbs, VacationFilter, VacationTable, VacationCreateDialog },
}
</script>
